export default "__VITE_ASSET__DJVH38aS__"